import { render, staticRenderFns } from "./default-cab.vue?vue&type=template&id=2c840e15&"
import script from "./default-cab.vue?vue&type=script&lang=js&"
export * from "./default-cab.vue?vue&type=script&lang=js&"
import style0 from "./default-cab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports